import { useEffect } from "react";
const DEFAULT_TITLE = "Jewish Meditation | Management";
export const useTitlePage = (title: string) => {
  useEffect(() => {
    if (title) {
      document.title = `${title} | ${DEFAULT_TITLE}`;
    } else {
      document.title = DEFAULT_TITLE;
    }
    // returned function will be called on component unmount
    return () => {
      document.title = DEFAULT_TITLE;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title]);
};
